



































import { computed, defineComponent, PropType, ref, watch } from "@vue/composition-api";
import { FileType, isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseIcon from "@/components/Base/BaseIcon";

type ThumbnailFile = Exclude<FileType, File> & { urlPart: string };

/**
 * Small preview of a file for the thumbnail strip of FullScreen:
 * an image, a frame of a video (with a play badge) or a document icon.
 * A locked file keeps the preview the viewer shows for it (blurred when the viewer blurs it) and gets a lock badge.
 */
export default defineComponent({
  name: "FullScreenFileThumbnail",
  components: { BaseIcon },
  props: {
    file: { type: Object as PropType<ThumbnailFile | null>, default: null },
    locked: { type: Boolean, default: false },
    blurred: { type: Boolean, default: false },
  },
  setup(props) {
    const isVideo = computed(() => !!props.file && isVideoFile(props.file));
    const isImage = computed(() => !!props.file && isImageFile(props.file));
    const src = computed(() => {
      if (!props.file?.urlPart) return "";
      if (isVideo.value) return MediaFilesController.getVideoThumbnail(props.file.urlPart, "240p");
      if (isImage.value) return MediaFilesController.getImageThumbnail(props.file.urlPart, "240p");
      return "";
    });

    // preview not ready yet (video still converting): the document icon instead of a broken image
    const failed = ref(false);
    watch(src, () => (failed.value = false));

    return { src, isVideo, failed };
  },
});
